import Alpine from 'alpinejs';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const desktopMediaQuery = '(min-width: 768px)';

Alpine.data('teamIntroduction', () => ({
    media: null,

    init() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        const root = this.$root;
        const layers = gsap.utils.toArray(root.querySelectorAll('[data-team-introduction-layer]'));

        if (!layers.length) {
            return;
        }

        gsap.registerPlugin(ScrollTrigger);

        this.media = gsap.matchMedia();
        this.media.add(desktopMediaQuery, () => {
            const tweens = layers.map((layer, index) => {
                const speed = Number(layer.dataset.parallaxSpeed || index + 1);
                const distance = () => speed * 62;

                return gsap.fromTo(
                    layer,
                    {
                        y: () => distance(),
                    },
                    {
                        y: () => distance() * -1,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: root,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                    }
                );
            });

            root.querySelectorAll('img').forEach((image) => {
                if (!image.complete) {
                    image.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
                }
            });

            requestAnimationFrame(() => ScrollTrigger.refresh());

            return () => {
                tweens.forEach((tween) => tween.kill());
                gsap.set(layers, { clearProps: 'transform' });
            };
        });
    },

    destroy() {
        this.media?.revert();
    },
}));
